/* ============================================================
   dr.GUT — Abertura suave da Informação nutricional

   O bloco é um <details> nativo. Ele não tem meio-termo: o conteúdo
   existe ou não existe, e a troca acontece num quadro só — daí a
   sensação de corte seco.

   Aqui a altura é animada de 0 até a altura real do conteúdo, e o
   contrário ao fechar. Fechando, o atributo `open` só é removido no
   fim: enquanto a animação roda, o conteúdo precisa continuar no DOM
   para ter o que encolher.

   Ouvinte delegado no documento, e não um por bloco: no editor de
   temas a seção é redesenhada a cada ajuste, e ouvintes presos aos
   elementos antigos morreriam junto com eles.
   ============================================================ */
(function () {
  'use strict';

  var ABRINDO = 300;
  var FECHANDO = 240;
  var CURVA = 'cubic-bezier(.3, .8, .4, 1)';

  /* Uma animação por bloco, para um clique repetido no meio do caminho
     cancelar a anterior em vez de disputar a mesma altura com ela. */
  var emCurso = new WeakMap();

  function semMovimento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animar(det, corpo, abrindo) {
    var anterior = emCurso.get(det);
    if (anterior) anterior.cancel();

    var altura = corpo.scrollHeight;
    var quadros = abrindo
      ? [{ height: '0px', opacity: 0 }, { height: altura + 'px', opacity: 1 }]
      : [{ height: altura + 'px', opacity: 1 }, { height: '0px', opacity: 0 }];

    /* Sem recorte, o conteúdo vazaria para fora da caixa enquanto ela
       ainda é menor que ele. Volta ao normal no fim, para não cortar
       uma tabela larga que role na horizontal. */
    corpo.style.overflow = 'hidden';

    var anim = corpo.animate(quadros, {
      duration: abrindo ? ABRINDO : FECHANDO,
      easing: CURVA,
    });
    emCurso.set(det, anim);

    anim.onfinish = function () {
      emCurso.delete(det);
      corpo.style.overflow = '';
      if (!abrindo) det.open = false;
    };

    /* Cancelada por um clique novo: devolve o elemento ao estado limpo
       e deixa a animação seguinte assumir. */
    anim.oncancel = function () {
      corpo.style.overflow = '';
    };
  }

  document.addEventListener('click', function (evento) {
    var resumo = evento.target.closest && evento.target.closest('.drgut-nut-sum');
    if (!resumo) return;

    var det = resumo.parentElement;
    if (!det || det.tagName !== 'DETAILS') return;

    var corpo = det.querySelector('.drgut-nut-body');
    if (!corpo || semMovimento()) return;

    /* O padrão do navegador troca o estado na hora; quem decide quando
       ele muda, aqui, é a animação. */
    evento.preventDefault();

    if (det.open) {
      animar(det, corpo, false);
      return;
    }

    /* Abrir um fecha os outros da mesma coluna. Sem isto a página cresce
       a cada abertura e o que a pessoa acabou de abrir some da tela.

       Os irmãos são procurados no mesmo pai — assim a coluna da galeria e
       a das informações não fecham uma à outra quando os blocos estão
       divididos entre as duas. */
    var vizinhos = det.parentElement && det.parentElement.parentElement
      ? det.parentElement.parentElement.querySelectorAll('.drgut-nut-det[open]')
      : [];
    [].forEach.call(vizinhos, function (outro) {
      if (outro === det) return;
      var c = outro.querySelector('.drgut-nut-body');
      if (c) animar(outro, c, false);
      else outro.open = false;
    });

    det.open = true;
    animar(det, corpo, true);
  });
})();
